import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'web-app';
  
  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.authService.restoreSessionFromLocalStorage();
  }
}
